import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      try {
        // Extract session_id from URL hash
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.replace('#', ''));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id in URL');
          navigate('/login', { replace: true });
          return;
        }

        // Exchange session_id for JWT via backend
        const response = await axios.post(`${API}/auth/google-callback`, {
          session_id: sessionId
        }, { withCredentials: true });

        const { access_token } = response.data;

        // Store token
        localStorage.setItem('access_token', access_token);

        // Clear the hash so AppRoutes stops rendering AuthCallback
        window.history.replaceState(null, '', '/');

        // Refresh auth context — this sets user state before we navigate
        await checkAuth();

        // Navigate to dashboard (user is now set, no flash)
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Google auth callback error:', error);
        const errorMsg = error.response?.data?.detail || 'Google sign-in failed. Please try again.';
        // Clear hash and navigate to login with error message
        window.history.replaceState(null, '', '/login');
        navigate('/login', { replace: true, state: { googleError: errorMsg } });
      }
    };

    processCallback();
  }, [navigate, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#002FA7] mx-auto" />
        <p className="mt-4 text-slate-500 text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
